import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import { Input } from "@mui/material";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";

class ReportConstructorCreatePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.report !== undefined && props.report !== null ? `"Пользовательский" ${props.report.title}` : null,
      buildType: props.report !== undefined && props.report !== null ? props.report.buildType : null,
      isTitleEdit: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { createCustomReportDataState, onCancelCreate } = this.props;

    if (prevProps.createCustomReportDataState === states.REQUEST && createCustomReportDataState === states.READY) {
      onCancelCreate();
    }
  }

  onCancel() {
    const { onCancelCreate } = this.props;

    onCancelCreate();
  }

  onCreate() {
    const { onCreateCustomReport } = this.props;
    const { title, buildType } = this.state;

    onCreateCustomReport({ title, buildType });
  }

  onChangeTitle(title) {
    this.setState({ title });
  }

  render() {
    const { title, isTitleEdit } = this.state;
    const { createCustomReportDataState } = this.props;

    return (
      <div className={styles.reportConstructrCreatePanelContainer}>
        {isTitleEdit ? (
          <div className={styles.reportTitleEditing}>
            <Input
              name="customReportTitle"
              type="text"
              onChange={(e) => {
                this.onChangeTitle(e.target.value);
              }}
              placeholder="Наименование пользовательского отчета"
              defaultValue={title}
              fullWidth={true}
            />
            <div>
              <EditOffIcon
                fontSize="inherit"
                className={styles.reportTitleEditButton}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ isTitleEdit: false });
                }}
              />
            </div>
          </div>
        ) : (
          <div className={styles.reportTitle}>
            {title}
            <div
              className={styles.reportTitleEditButton}
              onClick={(e) => {
                e.stopPropagation();
                this.setState({ isTitleEdit: true });
              }}
            >
              <EditIcon fontSize="inherit" />
            </div>
          </div>
        )}

        {createCustomReportDataState !== states.REQUEST ? (
          <div className={styles.confirmButtonsContainer}>
            <div className={styles.confirmButtonContainer}>
              <ButtonPrimary
                disabled={title === null || title === ""}
                handleClick={(e) => {
                  e.stopPropagation();
                  this.onCreate();
                }}
                title="Готов"
              />
            </div>
            <div className={styles.confirmButtonContainer}>
              <ButtonPrimary
                handleClick={(e) => {
                  e.stopPropagation();
                  this.onCancel();
                }}
                title="Отмена"
              />
            </div>
          </div>
        ) : (
          <Preloader />
        )}
      </div>
    );
  }
}

export default withCustomReport(React.memo(ReportConstructorCreatePanel));
